import { Routes } from '@angular/router';
// Guard imports
import { AuthGuard } from './_guards/auth.guard';
import { AccessGuard } from './_guards/access.guard';
import { CommunityGuard } from './_guards/community.guard';
import { ContextGuard } from './_guards/context.guard';
import { DataGuard } from './_guards/data.guard';
// Component imports
import { SearchComponent } from './search/search.component';
import { ContactUsComponent } from './shared-components/contact-us/contact-us.component';
import { HomeComponent } from './shared-components/home/home.component';
import { TimeExpenseConfirmationComponent } from './time-expense-submission-history-confirmation/components/time-expense-confirmation/time-expense-confirmation.component';
import { WorkQueueActionsComponent } from './work-queue-actions-confirmation/work-queue-actions/work-queue-actions.component';
import { ContactPageComponent } from './shared-components/contact-us/contact-page/contact-page.component';
const ɵ0 = { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true }, ɵ1 = () => import("./lotunit-tools-module/lotunit.module.ngfactory").then((m) => m.LotUnitModuleNgFactory), ɵ2 = { anonymousAccess: false, newWindow: true, resizable: false }, ɵ3 = () => import("./email-templates-module/email-templates.module.ngfactory").then((m) => m.EmailTemplatesModuleNgFactory), ɵ4 = { anonymousAccess: true, newWindow: true, resizable: false, outletOnly: true }, ɵ5 = () => import("./help-module/help.module.ngfactory").then((m) => m.HelpModuleNgFactory), ɵ6 = { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true }, ɵ7 = () => import("./ciramail-module/ciramail.module.ngfactory").then((m) => m.CiramailModuleNgFactory), ɵ8 = () => import("./user-module/user.module.ngfactory").then((m) => m.UserModuleNgFactory), ɵ9 = { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true }, ɵ10 = () => import("./mywork/mywork.module.ngfactory").then((m) => m.MyworkModuleNgFactory), ɵ11 = () => import("./workflow/workflow.module.ngfactory").then((m) => m.WorkflowModuleNgFactory), ɵ12 = () => import("./community-module/community.module.ngfactory").then((m) => m.CommunityModuleNgFactory), ɵ13 = () => import("./property-module/property.module.ngfactory").then((m) => m.PropertyModuleNgFactory), ɵ14 = () => import("./cirabooks/community-cirabooks-module/community-cirabook.module.ngfactory").then((m) => m.CommunityCirabooksModuleNgFactory), ɵ15 = () => import("./cirabooks/corporate-cirabooks-module/corporate-cirabooks.module.ngfactory").then((m) => m.CorporateCirabooksModuleNgFactory), ɵ16 = () => import("./cirabooks/general-cirabooks-module/general-cirabooks.module.ngfactory").then((m) => m.GeneralCirabooksModuleNgFactory), ɵ17 = () => import("./manage-property-module/manage-property.module.ngfactory").then((m) => m.ManagePropertyModuleNgFactory), ɵ18 = () => import("./configuration-module/configuration.module.ngfactory").then((m) => m.ConfigurationModuleNgFactory), ɵ19 = () => import("./configurations-module/configurations-routing.module.ngfactory").then((m) => m.ConfigurationsRoutingModuleNgFactory), ɵ20 = () => import("./user-portfolio-module/user-portfolio.module.ngfactory").then((m) => m.UserPortfolioModuleNgFactory), ɵ21 = () => import("./community-property-workspace-module/community-property-workspace.module.ngfactory").then((m) => m.CommunityPropertyWorkspaceModuleNgFactory), ɵ22 = () => import("./reports-module/reports.module.ngfactory").then((m) => m.ReportsModuleNgFactory), ɵ23 = { anonymousAccess: true, newWindow: true, resizable: false, outletOnly: true }, ɵ24 = () => import("./email-viewer-module/email-viewer.module.ngfactory").then((m) => m.EmailViewerModuleNgFactory), ɵ25 = { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true }, ɵ26 = () => import("./my-calendar-module/my-calendar.module.ngfactory").then((m) => m.MyCalendardModuleNgFactory), ɵ27 = () => import("./violations-configuration-module/violations-configuration.module.ngfactory").then((m) => m.ViolationsConfigurationModuleNgFactory), ɵ28 = () => import("./closing-portal-configuration-module/closing-portal-configuration.module.ngfactory").then((m) => m.ClosingPortalConfigurationModuleNgFactory), ɵ29 = () => import("./community-configuration-module/community-configuration.module.ngfactory").then((m) => m.CommunityConfigurationModuleNgFactory), ɵ30 = () => import("./collections-configuration-module/collections-configuration.module.ngfactory").then((m) => m.CollectionsConfigurationModuleNgFactory), ɵ31 = () => import("./ca-accounting-module/ca-accounting.module.ngfactory").then((m) => m.CAAccountingModuleNgFactory);
const appRoutes = [
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'search',
        data: ɵ0,
        component: SearchComponent,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'contact-us',
        component: ContactUsComponent,
        canActivate: [AuthGuard]
    },
    {
        path: ':communityId/search',
        component: SearchComponent,
        canActivate: [AuthGuard, AccessGuard, CommunityGuard, ContextGuard]
    },
    {
        path: 'tools',
        loadChildren: ɵ1,
        canActivate: [AuthGuard]
    },
    {
        // Research and Development Module for Email Templates
        path: 'email-templates',
        data: ɵ2,
        loadChildren: ɵ3,
        canActivate: [AuthGuard]
    },
    {
        path: 'cirahelp',
        data: ɵ4,
        loadChildren: ɵ5
    },
    {
        path: 'ciramail',
        data: ɵ6,
        loadChildren: ɵ7,
        canActivate: [AuthGuard]
    },
    {
        path: 'user',
        loadChildren: ɵ8
    },
    {
        path: 'TESAction',
        component: TimeExpenseConfirmationComponent
    },
    {
        path: 'workQueueActions',
        component: WorkQueueActionsComponent
    },
    {
        path: 'ciranet-support',
        component: ContactPageComponent,
        data: ɵ9,
        canActivate: [AuthGuard, DataGuard]
    },
    {
        path: 'my-work',
        loadChildren: ɵ10
    },
    {
        path: 'workflow',
        loadChildren: ɵ11
    },
    {
        path: 'community',
        loadChildren: ɵ12,
        canActivate: [AuthGuard]
    },
    {
        path: 'property',
        loadChildren: ɵ13,
        canActivate: [AuthGuard]
    },
    {
        path: 'cb',
        loadChildren: ɵ14,
        canActivate: [AuthGuard]
    },
    {
        path: 'ccb',
        loadChildren: ɵ15,
        canActivate: [AuthGuard]
    },
    {
        path: 'gcb',
        loadChildren: ɵ16,
        canActivate: [AuthGuard]
    },
    {
        path: 'manage-property',
        loadChildren: ɵ17,
        canActivate: [AuthGuard]
    },
    {
        path: 'configuration',
        loadChildren: ɵ18,
        canActivate: [AuthGuard]
    },
    {
        path: 'configurations',
        loadChildren: ɵ19,
        canActivate: [AuthGuard]
    },
    {
        path: 'my-portfolio',
        loadChildren: ɵ20,
        canActivate: [AuthGuard]
    },
    {
        path: 'community-properties',
        loadChildren: ɵ21,
        canActivate: [AuthGuard]
    },
    {
        path: 'reports',
        loadChildren: ɵ22,
        canActivate: [AuthGuard]
    },
    {
        path: 'cira-view-email',
        data: ɵ23,
        loadChildren: ɵ24
    },
    {
        path: 'calendar',
        data: ɵ25,
        loadChildren: ɵ26,
        canActivate: [AuthGuard]
    },
    {
        path: 'violations-configurations',
        loadChildren: ɵ27,
        canActivate: [AuthGuard]
    },
    {
        path: 'closing-portal-configurations',
        loadChildren: ɵ28,
        canActivate: [AuthGuard]
    },
    {
        path: 'community-configurations',
        loadChildren: ɵ29,
        canActivate: [AuthGuard]
    },
    {
        path: 'collections-configurations',
        loadChildren: ɵ30,
        canActivate: [AuthGuard]
    },
    {
        path: 'ca-accounting',
        loadChildren: ɵ31,
        canActivate: [AuthGuard]
    },
    { path: '**', pathMatch: 'full', redirectTo: 'home' }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31 };
